import React from 'react';
import './Card.css';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
	variant?: 'default' | 'elevated' | 'outlined' | 'glass';
	padding?: 'none' | 'sm' | 'md' | 'lg';
	hover?: boolean;
	glow?: boolean;
}

/**
 * Reusable Card component
 */
export const Card: React.FC<CardProps> = ({
	children,
	variant = 'default',
	padding = 'md',
	hover = false,
	glow = false,
	className = '',
	...props
}) => {
	const classes = [
		'ui-card',
		`ui-card--${variant}`,
		`ui-card--padding-${padding}`,
		hover && 'ui-card--hover',
		glow && 'ui-card--glow',
		className,
	].filter(Boolean).join(' ');

	return (
		<div className={classes} {...props}>
			{children}
		</div>
	);
};

/* Sub-components */
export const CardHeader: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
	children,
	className = '',
	...props
}) => (
	<div className={`ui-card__header ${className}`} {...props}>
		{children}
	</div>
);

export const CardBody: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
	children,
	className = '',
	...props
}) => (
	<div className={`ui-card__body ${className}`} {...props}>
		{children}
	</div>
);

export const CardFooter: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
	children,
	className = '',
	...props
}) => (
	<div className={`ui-card__footer ${className}`} {...props}>
		{children}
	</div>
);

export default Card;




